import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {accountingRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {AccountingOverview} from './pages/AccountingOverview/AccountingOverview';
import {BalanceInvoiceDetail} from './pages/BalanceInvoiceDetail/BalanceInvoiceDetail';
import {CashReceiptDetail} from './pages/CashReceiptDetail/CashReceiptDetail';
import {CorrectiveTaxDocumentDetail} from './pages/CorrectiveTaxDocumentDetail/CorrectiveTaxDocumentDetail';
import {CreateCorrectiveTaxDocument} from './pages/CreateCorrectiveTaxDocument/CreateCorrectiveTaxDocument';
import {CreateCorrectiveTaxDocumentForAftersales} from './pages/CreateCorrectiveTaxDocumentForAftersales/CreateCorrectiveTaxDocumentForAftersales';
import {CreateExpenseCashReceipt} from './pages/CreateExpenseCashReceipt/CreateExpenseCashReceipt';
import {CreateIncomeCashReceipt} from './pages/CreateIncomeCashReceipt/CreateIncomeCashReceipt';
import {CreateInvoice} from './pages/CreateInvoice/CreateInvoice';
import {InvoiceDetail} from './pages/InvoiceDetail/InvoiceDetail';
import {ProformaInvoiceDetail} from './pages/ProformaInvoiceDetail/ProformaInvoiceDetail';
import {TaxDocumentForPaymentDetail} from './pages/TaxDocumentForPaymentDetail/TaxDocumentForPaymentDetail';

export const AccountingModule: Module = {
  id: moduleKeys.accounting,
  alwaysShowContent: true,
  layoutProps: {
    title: 'module.accounting.title',
    icon: 'sidebar/accounting',
  },
  routerProps: {
    path: accountingRoutes.invoiceOverview,
    element: <AccountingOverview />,
  },
  requiredPermission: permissions.readInvoice,
  content: [
    {
      id: 'invoice-overview',
      routerProps: {
        path: accountingRoutes.invoiceOverview,
        element: <AccountingOverview />,
      },
      layoutProps: {
        title: 'page.accounting.invoiceList.title',
        icon: 'sidebar/accounting_invoices',
      },
    },
    {
      id: 'accounting-cashReceipt',
      routerProps: {
        path: accountingRoutes.cashReceiptsOverview,
        element: <AccountingOverview />,
      },
      layoutProps: {
        title: 'page.accounting.cashRegister.title',
        icon: 'sidebar/accounting_cash_receipts',
      },
      requiredPermission: permissions.readCashRegisterDocument,
    },
    {
      id: 'invoice-new',
      routerProps: {
        path: accountingRoutes.invoiceNew,
        element: <CreateInvoice />,
      },
    },
    {
      id: 'incomeCashReceipt-new',
      routerProps: {
        path: accountingRoutes.createCashReceiptIncome,
        element: <CreateIncomeCashReceipt />,
      },
      requiredPermission: permissions.readCashRegisterDocument,
    },
    {
      id: 'expenseCashReceipt-new',
      routerProps: {
        path: accountingRoutes.createCashReceiptExpense,
        element: <CreateExpenseCashReceipt />,
      },
      requiredPermission: permissions.readCashRegisterDocument,
    },
    {
      id: 'CashReceipt-detail',
      routerProps: {
        path: accountingRoutes.cashReceiptDetail,
        element: <CashReceiptDetail />,
      },
      requiredPermission: permissions.readCashRegisterDocument,
    },
    {
      id: 'invoice-draft',
      routerProps: {
        path: accountingRoutes.invoiceDraft,
        element: <CreateInvoice />,
      },
    },
    {
      id: 'invoice-detail',
      routerProps: {
        path: accountingRoutes.invoiceDetail,
        element: <InvoiceDetail />,
      },
    },
    {
      id: 'balance-invoice-detail',
      routerProps: {
        path: accountingRoutes.balanceInvoiceDetail,
        element: <BalanceInvoiceDetail />,
      },
    },
    {
      id: 'tax-document-for-payment-detail',
      routerProps: {
        path: accountingRoutes.taxDocumentForPaymentDetail,
        element: <TaxDocumentForPaymentDetail />,
      },
    },
    {
      id: 'corrective-tax-document-detail',
      routerProps: {
        path: accountingRoutes.correctiveTaxDocumentDetail,
        element: <CorrectiveTaxDocumentDetail />,
      },
    },
    {
      id: 'proforma-invoice-detail',
      routerProps: {
        path: accountingRoutes.proformaInvoiceDetail,
        element: <ProformaInvoiceDetail />,
      },
    },
    {
      id: 'create-corrective-tax-document',
      routerProps: {
        path: accountingRoutes.newCorrectiveTaxDocument,
        element: <CreateCorrectiveTaxDocument />,
      },
    },
    {
      id: 'create-corrective-tax-document-for-aftersales',
      routerProps: {
        path: accountingRoutes.newCorrectiveTaxDocumentForAftersales,
        element: <CreateCorrectiveTaxDocumentForAftersales />,
      },
    },
  ],
};
